module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/header_images/header_1-0f6762ae51850e3cd51ec4129aeb842b.svg";